import {
  INPUT,
  NUMBER,
  NET_WORTH_TEXT,
  NET_WORTH_TEXT_ROW,
  ASSET_TEXT,
  LIABILITY_TEXT,
  NET_WORTH_ASSET_TEXT,
  NET_WORTH_LIABILITY_TEXT,
} from '..';

// Net Worth Modal Content Page
export const NET_WORTH_ADDING_PADDING = 'net-worth-adding-padding';
export const TRIPLE_FIELDS_WRAPPER = 'triple-fields-wrapper';

// For asset worth -
export const OTHER = 'Other';
export const other = 'other';

export const TOTAL_ASSETS = 'Total Assets';
export const total = 'total';

// NET WORTH MODAL
// Assets
export const ASSETS = 'Assets';
export const NET_WORTH_INFO = 'Net Worth Info';
export const SAVINGS_ACCOUNT = 'Savings Account';
export const CHECKING_ACCOUNT = 'Checking Account';
export const INVESTMENTS = 'Investments';
export const LIFE_INSURANCE_POLICY = 'Life Insurance Policy';
export const PENSION_EQUITY = 'Pension Equity';
export const PROFIT_SHARING_EQUITY = 'Profit Sharing Equity';
export const EMPLOYER_SHARING_PLAN = 'Employer Sharing Plan';
export const RETIREMENT_FUND = 'Retirement Fund';
export const REAL_ESTATE = 'Real Estate (including home)';

// Assets attribute
export const savingsAccount = 'savingsAccount';
export const checkingsAccount = 'checkingsAccount';
export const investmentAttribute = 'investment';
export const lifeInsurancePolicy = 'lifeInsurancePolicy';
export const pensionEquity = 'pensionEquity';
export const profitSharingEquity = 'profitSharingEquity';
export const employerSharingPlan = 'employerSharingPlan';
export const retirementFund = 'retirementFund';
export const realEstate = 'realEstate';

// Liabilities
export const LIABILITIES = 'Liabilities';
export const CREDIT_CARD_BILLS = 'Credit Card Bills';
export const UNPAID_MEDICAL_DENTAL_BILL = 'Unpaid Medical & Dental Bill';
export const MORTGAGE_BALANCE = 'Mortgage Balance';
export const HOME_EQUITY_LOANS = 'Home Equity Loans';
export const PENSION_LOANS = 'Pension Loans';
export const CAR_LOANS = 'Car Loans';
export const UNPAID_TAXES = 'Unpaid Taxes';

// Liabilities attributes
export const unpaidMedicalDentalBill = 'unpaidMedicalDentalBill';
export const mortgageBalance = 'mortgageBalance';
export const homeEquityLoan = 'homeEquityLoan';
export const pensionLoan = 'pensionLoan';
export const carLoan = 'carLoan';
export const unpaidTax = 'unpaidTax';
export const creditCardBill = 'creditCardBill';

// Net Worth
export const NET_WORTH = 'Net Worth';
export const ASSETS_AND_NET_WORTH_INFO = 'Assets and Net Worth Info';

export const TOTAL_LIABILITIES = 'Total Liabilities';

export const NET_WORTH_MODAL = {
  title: NET_WORTH_INFO,
  sections: {
    [ASSETS]: {
      rows: [
        [
          {
            label: SAVINGS_ACCOUNT,
            name: SAVINGS_ACCOUNT,
            schemaAttribute: savingsAccount,
            fieldType: INPUT,
            placeholder: '$',
            type: NUMBER,
            fullWidthOnMobile: true,
          },
          {
            label: CHECKING_ACCOUNT,
            name: CHECKING_ACCOUNT,
            schemaAttribute: checkingsAccount,
            fieldType: INPUT,
            placeholder: '$',
            type: NUMBER,
            fullWidthOnMobile: true,
          },
        ],
        [
          {
            label: INVESTMENTS,
            name: INVESTMENTS,
            schemaAttribute: investmentAttribute,
            fieldType: INPUT,
            placeholder: '$',
            type: NUMBER,
            fullWidthOnMobile: true,
          },
          {
            label: LIFE_INSURANCE_POLICY,
            name: LIFE_INSURANCE_POLICY,
            schemaAttribute: lifeInsurancePolicy,
            fieldType: INPUT,
            placeholder: '$',
            type: NUMBER,
            fullWidthOnMobile: true,
          },
        ],
        [
          {
            label: PENSION_EQUITY,
            name: PENSION_EQUITY,
            schemaAttribute: pensionEquity,
            fieldType: INPUT,
            placeholder: '$',
            type: NUMBER,
            fullWidthOnMobile: true,
          },
          {
            label: PROFIT_SHARING_EQUITY,
            name: PROFIT_SHARING_EQUITY,
            schemaAttribute: profitSharingEquity,
            fieldType: INPUT,
            placeholder: '$',
            type: NUMBER,
            fullWidthOnMobile: true,
          },
        ],
        [
          {
            label: EMPLOYER_SHARING_PLAN,
            name: EMPLOYER_SHARING_PLAN,
            schemaAttribute: employerSharingPlan,
            fieldType: INPUT,
            placeholder: '$',
            type: NUMBER,
            fullWidthOnMobile: true,
          },
          {
            label: RETIREMENT_FUND,
            name: RETIREMENT_FUND,
            schemaAttribute: retirementFund,
            fieldType: INPUT,
            placeholder: '$',
            type: NUMBER,
            fullWidthOnMobile: true,
          },
        ],
        [
          {
            label: REAL_ESTATE,
            name: REAL_ESTATE,
            schemaAttribute: realEstate,
            fieldType: INPUT,
            placeholder: '$',
            type: NUMBER,
            fullWidthOnMobile: true,
          },
          {
            label: OTHER,
            name: OTHER,
            schemaAttribute: other,
            fieldType: INPUT,
            placeholder: '$',
            type: NUMBER,
            fullWidthOnMobile: true,
          },
        ],
        [
          {
            fieldType: ASSET_TEXT,
            text: TOTAL_ASSETS,
            schemaAttribute: total,
            asset: () => {},
          },
        ],
      ],
    },
    [LIABILITIES]: {
      rows: [
        [
          {
            label: CREDIT_CARD_BILLS,
            name: CREDIT_CARD_BILLS,
            fieldType: INPUT,
            placeholder: '$',
            type: NUMBER,
            fullWidthOnMobile: true,
          },
          {
            label: UNPAID_MEDICAL_DENTAL_BILL,
            name: UNPAID_MEDICAL_DENTAL_BILL,
            fieldType: INPUT,
            placeholder: '$',
            type: NUMBER,
            fullWidthOnMobile: true,
          },
        ],
        [
          {
            label: MORTGAGE_BALANCE,
            name: MORTGAGE_BALANCE,
            fieldType: INPUT,
            placeholder: '$',
            type: NUMBER,
            fullWidthOnMobile: true,
          },
          {
            label: HOME_EQUITY_LOANS,
            name: HOME_EQUITY_LOANS,
            fieldType: INPUT,
            placeholder: '$',
            type: NUMBER,
            fullWidthOnMobile: true,
          },
        ],
        [
          {
            label: PENSION_LOANS,
            name: PENSION_LOANS,
            fieldType: INPUT,
            placeholder: '$',
            type: NUMBER,
            fullWidthOnMobile: true,
          },
          {
            label: CAR_LOANS,
            name: CAR_LOANS,
            fieldType: INPUT,
            placeholder: '$',
            type: NUMBER,
            fullWidthOnMobile: true,
          },
        ],
        [
          {
            label: UNPAID_TAXES,
            name: UNPAID_TAXES,
            fieldType: INPUT,
            placeholder: '$',
            type: NUMBER,
            fullWidthOnMobile: true,
          },
          {
            label: OTHER,
            name: OTHER,
            fieldType: INPUT,
            placeholder: '$',
            type: NUMBER,
            fullWidthOnMobile: true,
          },
        ],
        [
          {
            fieldType: LIABILITY_TEXT,
            text: TOTAL_LIABILITIES,
            liability: () => {},
          },
        ],
      ],
    },
    [NET_WORTH]: {
      rows: [
        [
          {
            label: ASSETS,
            name: ASSETS,
            fieldType: NET_WORTH_ASSET_TEXT,
            text: ASSETS,
            style: { textAlign: 'center' },
          },
          {
            label: LIABILITIES,
            name: LIABILITIES,
            fieldType: NET_WORTH_LIABILITY_TEXT,
            text: LIABILITIES,
            style: { textAlign: 'center' },
          },
          {
            label: NET_WORTH,
            name: NET_WORTH,
            fieldType: NET_WORTH_TEXT,
            text: NET_WORTH,
            style: { textAlign: 'center' },
          },
        ],
        [
          {
            fieldType: NET_WORTH_TEXT_ROW,
            text: NET_WORTH,
          },
        ],
      ],
    },
  },
};
